import {useRef} from "react";
import type {NavigateFunction} from "react-router";
import {ItemPillLayout, MiniPill, QuantityPill} from "../../features/items/ItemPill";
import type {GroupRepo, IngredientEntry, ItemEntry} from "../../models/GroupRepo";
import PlusMinusButtons from "../../shared/PlusMinusButtons";
import {blueTheme} from "../../styles/themes/color-themes.css";
import {Col, css, Row} from "../../ui/Box";
import Icon from "../../ui/Icon";
import {useDndItem} from "../../utils/list-dnd/use-dnd-list";

type EditIngredientPillProps = {
  item: ItemEntry;
  ingredient: IngredientEntry;
  navigate: NavigateFunction;
  startPx: number;
  index: number;
  groupRepo: GroupRepo;
};
export const EditIngredientPill = (props: EditIngredientPillProps) => {
  const {item, ingredient, navigate, startPx, index, groupRepo} = props;
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const {handlers, transform} = useDndItem({nodeRef, index, startPx, key: ingredient.id});

  const handleUpdate = (next: number) => {
    groupRepo.Ingredients.patch(ingredient.id, {quantity: next});
  };

  const handleDelete = () => {
    groupRepo.Ingredients.delete(ingredient.id);
  };

  return (
    <Row style={{transform}} ref={nodeRef} absolute top="0" left="0" width="100%" sp="4">
      <Col align="center" justify="center" pr="8" {...handlers}>
        <Icon name="menu" size="24" />
      </Col>
      <ItemPillLayout
        name={item.name}
        emoji={item.emoji}
        theme={blueTheme}
        onLongClick={() => {
          navigate(`ingredient/${ingredient.id}`);
        }}
        className={css({flex: "auto"})}
      >
        <Row flex="none" relative>
          <Row wrap sp="4" absolute justify="end" bottom="0" right="100%" px="4" pb="4">
            <QuantityPill variant={ingredient} />
            {ingredient.variant && <MiniPill>{ingredient.variant}</MiniPill>}
          </Row>
          <PlusMinusButtons
            value={ingredient.quantity}
            onUpdate={handleUpdate}
            onDelete={handleDelete}
          />
        </Row>
      </ItemPillLayout>
    </Row>
  );
};
type IngredientPillProps = {
  item: ItemEntry;
  ingredient: IngredientEntry;
  ratio?: number;
};
const IngredientPill = ({item, ingredient, ratio}: IngredientPillProps) => {
  return (
    <ItemPillLayout name={item.name} emoji={item.emoji} theme={blueTheme}>
      <Row flex="none" relative>
        <Row wrap sp="4" absolute justify="end" bottom="0" right="100%" px="4" pb="4">
          <QuantityPill
            variant={
              ratio && ratio !== 1
                ? {quantity: ingredient.quantity * ratio, unit: ingredient.unit}
                : ingredient
            }
          />
          {ingredient.variant && <MiniPill>{ingredient.variant}</MiniPill>}
        </Row>
      </Row>
    </ItemPillLayout>
  );
};

export default IngredientPill;
